import { createFileRoute } from '@tanstack/react-router';
import { KpiPage } from '@/features/kpi/pages/kpi-page';

export const Route = createFileRoute('/_app/kpi')({ component: KpiPage });
